import React, { useEffect } from 'react'
import { Stack, Typography } from '@mui/material'
import { object, string } from 'yup'

import { B2CTransferCheckSuccessResponse, B2CTransferConfirmForm } from '../../../../@types/b2c.types.ts'
import { InfoBox, useSnackbarContext, VerifyCodeField } from '../../../../components'
import { Form, FormSchema, FormSchemaMessages, SubmitButton } from '../../../../components/form'
import { B2C_ENDPOINTS, useMutateB2CResendCode, useMutateB2cTransferConfirm } from '../../../../services'

const B2C_TRANSFER_CONFIRM_FORM_NAME = 'newB2CTransferConfirm'

const verifyB2CFormSchema = object<FormSchema<B2CTransferConfirmForm>>({
  code: string().required(FormSchemaMessages.required),
})

export interface B2CConfirmDialogProps extends B2CTransferCheckSuccessResponse {
  onSuccess(): void
}

export const B2CConfirmDialog = ({ clientPAM, id, onSuccess }: B2CConfirmDialogProps): React.ReactElement => {
  const handleB2CCode = useMutateB2CResendCode()
  const handleConfirm = useMutateB2cTransferConfirm()
  const { addSnack } = useSnackbarContext()

  useEffect(() => {
    handleB2CCode.mutate()
  }, [])

  useEffect(() => {
    switch (handleConfirm.status) {
      case 'success': {
        const response = handleConfirm.data?.data
        const isSuccess = response?.state === 'OK'

        addSnack({
          message: isSuccess
            ? response.message ?? 'Возврат платежа в процессе'
            : response.message ?? 'Произошла ошибка при создании возврата, попробуйте ещё раз',
          severity: isSuccess ? 'success' : 'error',
          timeout: isSuccess ? 6000 : 3000,
          closeIcon: false,
        })
        if (isSuccess) {
          onSuccess()
          handleConfirm.reset()
        }
        break
      }
      case 'error': {
        const { error } = handleConfirm
        addSnack({
          message: error.response?.data?.errorDetails ?? 'Произошла непредвиденная ошибка, попробуйте ещё раз',
          severity: 'error',
          timeout: 3000,
          closeIcon: false,
        })
        handleConfirm.reset()
        break
      }
      default:
        break
    }
  }, [handleConfirm.status])

  const handleSumbit = async (form: B2CTransferConfirmForm) => {
    try {
      await handleConfirm.mutateAsync({ ...form, id })
      onSuccess()
    } catch (e) {
      console.log()
    }
  }

  return (
    <Form name={B2C_TRANSFER_CONFIRM_FORM_NAME} validationSchema={verifyB2CFormSchema} onSubmit={handleSumbit}>
      <Stack gap={2}>
        <InfoBox severity="success">
          <Stack direction="column">
            <Typography>
              <b>ФИО получателя: </b>
              {clientPAM}
            </Typography>
          </Stack>
        </InfoBox>

        <Stack gap={2}>
          {handleB2CCode.data?.data?.message && <Typography>{handleB2CCode.data?.data.message}</Typography>}
          <VerifyCodeField login={''} apiUrl={B2C_ENDPOINTS.resendCode} codeLifespanMin={1} />
        </Stack>
        <SubmitButton form={B2C_TRANSFER_CONFIRM_FORM_NAME}>Подвердить</SubmitButton>
      </Stack>
    </Form>
  )
}
